var render, staticRenderFns
import script from "./CustomGenericDocumentAtasYear.vue?vue&type=script&lang=js"
export * from "./CustomGenericDocumentAtasYear.vue?vue&type=script&lang=js"
import style0 from "./CustomGenericDocumentAtasYear.vue?vue&type=style&index=0&id=5957445e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5957445e",
  null
  
)

export default component.exports